
export const CLEAR_NOTIFICATION = 'clear-notification';
export const ADD_NOTIFICATION = 'add-notification';
